<template>
	<c-dialog ref="dialog" title="站内信详情" enable-flex width="800" mode="slide" mask-close :button="false">
        <div class="m-detail-box">
            <c-detail>
                <c-detail-item label="标题">
                    {{detailData.title}}
                    <c-link v-if="detailData.redirect_url" @click="toBusinessDetail()">{{title}}</c-link>
                </c-detail-item>
                <c-detail-item label="内容">
                    {{detailData.content}}
                </c-detail-item>
                <c-detail-item label="创建时间">
                    {{detailData.create_date}}
                </c-detail-item>
            </c-detail>
        </div>
    </c-dialog>
</template>

<script>
	import {mapState} from "vuex";

	export default {
		name: 'messageDetail',

		computed: {
		},

		props: {
		},

		data() {
			return {
                title:'详情',
                detailData: {}
            }
		},
		
		methods: {
			/************打开新增、编辑弹窗**************/
            open(data) {
                this.detailData = data;
                let jsonObj = JSON.parse(this.detailData.params);
                if (jsonObj && jsonObj.id && this.detailData.redirect_url == '/aftersales/work/detail'){       //工单详情
                    this.title = '工单详情';
                }else if (jsonObj && jsonObj.id && this.detailData.redirect_url == '/assets/receive/detail'){  //物资领用
                    this.title = '物资领用详情';
                }else if (jsonObj && jsonObj.id && this.detailData.redirect_url == '/aftersales/outsource/detail'){  //外协招工
                    this.title = '外协招工详情';
                }else if (jsonObj && jsonObj.id && this.detailData.redirect_url == '/assets/return/detail'){  //物资归还
                    this.title = '物资归还详情';
                }else if (jsonObj && jsonObj.id && this.detailData.redirect_url == '/affairs/leave/detail'){  //请假
                    this.title = '请假详情';
                }else if (jsonObj && jsonObj.id && this.detailData.redirect_url == '/finance/reimb/detail'){  //请假
                    this.title = '费用报销详情';
                }
                //弹窗
                this.$refs.dialog.open();
            },
            //跳转业务详情
            toBusinessDetail(){
                let jsonObj = JSON.parse(this.detailData.params);
                console.log(jsonObj);
                if (jsonObj && jsonObj.id && this.detailData.redirect_url == '/aftersales/work/detail'){       //工单详情
                    this.globalDialog('afterSaleOrderDetail', {props: {id: jsonObj.id}})
                }else if (jsonObj && jsonObj.id && this.detailData.redirect_url == '/assets/receive/detail'){  //物资领用
                    this.globalDialog('assetReceiveApplyDetail', {props: {id: jsonObj.id}})
                }else if (jsonObj && jsonObj.id && this.detailData.redirect_url == '/aftersales/outsource/detail'){  //外协招工
                    this.globalDialog('outsourceRrecruitDetail', {props: {id: jsonObj.id}})
                }else if (jsonObj && jsonObj.id && this.detailData.redirect_url == '/assets/return/detail'){  //物资归还
                    this.globalDialog('assetReturnApplyDetail', {props: {id: jsonObj.id}})
                }else if (jsonObj && jsonObj.id && this.detailData.redirect_url == '/affairs/leave/detail'){  //请假
                    this.globalDialog('leaveApplicationDetail', {props: {id: jsonObj.id}})
                }else if (jsonObj && jsonObj.id && this.detailData.redirect_url == '/finance/reimb/detail'){  //请假
                    this.globalDialog('expenseReimbursementDetail', {props: {id: jsonObj.id}})
                }
            }
		}
	}
</script>

<style lang="stylus" scoped>
</style>
